import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  save() {
    const form = document.getElementById("section-name-form")
    if (form) {
      form.submit()
    }
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    }
  }
}
